import * as React from 'react';

export default function Stellar(props) {
  const { width = 150, height = 150, primary = "#14B6E7" } = props;
  
  // Stellar logo is circular, maintain 1:1 aspect ratio
  const actualHeight = height || width;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={actualHeight}
      viewBox="0 0 24 24"
      fill="none">
      {/* Scale and center the official Stellar logo, compensating for padding */}
      <g transform="translate(8, 10) scale(0.045) translate(-280, -300)">
        <path 
          d="M342.9,124.7c24.9,0,49,4.9,71.8,14.5c12.1,5.1,23.7,11.6,34.5,19.2l-2.3,1.2l-29.6,15.1c-22.6-12.6-48.3-19.2-74.4-19.2c-0.4,0-0.8,0-1.2,0c-20.1,0.2-39.7,4.2-58.2,11.9c-18.5,7.8-35.1,18.9-49.3,33.1c-29,29.1-45,67.7-45,108.7c0,6.7,0.4,13.4,1.3,20.1l0.3,2.1l1.9-1l255.5-130.3l52.9-27l59.9-30.6v34.6l-61.7,31.5l-30.3,15.4L199.7,361.5l-1.2,0.7l0,0l-13.8,7l-14,7.1l0-0.1l-1.3,0.6l-44.8,22.9v-34.6l15.2-7.7c12.7-6.5,20.3-19.9,19.2-34.2c-0.3-4.7-0.5-9.4-0.5-14.1c0-24.9,4.9-49.1,14.5-71.9c9.3-22,22.6-41.7,39.5-58.7c16.9-16.9,36.6-30.3,58.6-39.6C293.8,129.6,318,124.7,342.9,124.7" 
          fill="black"
        />
        <path 
          d="M561.1,223.4V258l-15.2,7.7c-12.7,6.5-20.3,19.9-19.2,34.2c0.4,4.7,0.5,9.5,0.5,14.2c0,24.9-4.9,49.1-14.5,71.9c-9.3,22-22.6,41.7-39.5,58.7c-16.9,17-36.7,30.3-58.6,39.6c-22.7,9.6-46.9,14.5-71.8,14.5s-49-4.9-71.8-14.5c-12.2-5.2-23.8-11.7-34.6-19.3l30.6-15.6l1.2-0.6c22.6,12.6,48.4,19.3,74.6,19.3c0.4,0,0.7,0,1.1,0c20.1-0.1,39.7-4.1,58.2-11.9c18.5-7.8,35.1-18.9,49.3-33.1c29-29,45-67.7,45-108.7c0-6.7-0.4-13.5-1.3-20.2l-0.3-2.1l-1.9,1L237.2,423.2l-52.9,27l-59.7,30.4V446l61.5-31.4l30.3-15.4L561.1,223.4" 
          fill="black"
        />
      </g>
    </svg>
  );
}